import { render, staticRenderFns } from "./unload-detail.vue?vue&type=template&id=b1051ed0&"
import script from "./unload-detail.vue?vue&type=script&lang=js&"
export * from "./unload-detail.vue?vue&type=script&lang=js&"
import style0 from "./unload-detail.vue?vue&type=style&index=0&id=b1051ed0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports